import { controlePatientModalBodyStyle, controlePatientModalHeaderStyle, controlePatientModalOverlayStyle, controlePatientModalStyle } from "../bisPatientStyles";
import { renderPatientControleTab } from "./PatientControleTabView";
import { modalCloseButtonStyle } from "../../shared/styles/layoutStyles";
import ModalBackdrop from "../../../../components/ModalBackdrop";

export function renderControlePatientModal(view) {
    const { controle, setShowControlePatientModal, showControlePatientModal, validatedPatientCount } = view;
    if (!showControlePatientModal) return null;
    return (
        <div style={controlePatientModalOverlayStyle}>
            <ModalBackdrop onClose={() => setShowControlePatientModal(false)} />
            <div role="dialog" aria-modal="true" aria-labelledby="controle-patient-modal-title" style={{ ...controlePatientModalStyle, position: "relative", zIndex: 1 }}>
                <div style={controlePatientModalHeaderStyle}>
                    <div>
                        <h2 id="controle-patient-modal-title" style={{ margin: 0, color: "#0f172a", fontSize: "18px", fontWeight: 950 }}>Contrôle patient</h2>
                        <div style={{ color: "#64748b", fontSize: "13px", marginTop: "3px" }}>
                            {validatedPatientCount}/{controle.patients.length} patient{controle.patients.length > 1 ? "s" : ""} validé{validatedPatientCount > 1 ? "s" : ""}
                        </div>
                    </div>
                    <button type="button" onClick={() => setShowControlePatientModal(false)} style={modalCloseButtonStyle}>×</button>
                </div>
                <div style={controlePatientModalBodyStyle}>
                    {renderPatientControleTab(view)}
                </div>
            </div>
        </div>
    );
}
